module.exports = "img/photo17.0bb2b4.jpg";